import { Component, inject, OnInit } from '@angular/core';
import { ApiGatewayService, AppContextService, EcaSecurityService, WindowService } from '@drc-eca/eca-components-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { PortalService } from '../portal.service';
import { LoginMessageService } from '../services/login-message.service';

@Component({
    selector: 'app-saml-login',
    templateUrl: './saml-login.component.html',
    styleUrls: ['./saml-login.component.scss']
})
export class SamlLoginComponent implements OnInit {
  private apiGatewayService = inject(ApiGatewayService)
  private appContextService = inject(AppContextService)
  private loginMessageService = inject(LoginMessageService)
  private portalService = inject(PortalService)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private securityService = inject(EcaSecurityService)
  private windowService = inject(WindowService)

  constructor() {}

  async ngOnInit() {
    const {token, extras} = await firstValueFrom(this.route.params.pipe(take(1)));

    let productCode: string | null = null;
    let returnUrl: string | null = null;

    if (extras) {
      for (const extra of JSON.parse(extras) as string[]) {
        if (extra.startsWith('c:')) {
          productCode = extra.split('c:')[1];
        }

        if (extra.startsWith('returnUrl:')) {
          returnUrl = extra.split('returnUrl:')[1];
        }
      }
    }

    try {
      await firstValueFrom(this.securityService.authenticateToken(token));
      this.appContextService.setToken(token);
      this.appContextService.setPortalUrl(this.portalService.getPortalUrl(location));
      this.apiGatewayService.clearCache();

      // restore product code set by product-login.component.ts
      this.appContextService.setSelectedProductCode(productCode as string);

      // navigate to redirect URL when one was provided
      if (returnUrl) {
        // navigate to the product selection page first when no product is specified
        if (!productCode) {
          const redirectUrlWithParams = `${this.portalService.getPortalUrl(location)}/#/products?t=${token}&returnUrl=${encodeURIComponent(decodeURIComponent(returnUrl))}`;
          this.windowService.navigateTo(redirectUrlWithParams);
          return;
        }

        // navigate directly to the returnUrl when a product is specified
        const redirectUrlWithParams = new URL(returnUrl);
        redirectUrlWithParams.searchParams.set('t', token);
        redirectUrlWithParams.searchParams.set('c', productCode);
        this.windowService.navigateTo(redirectUrlWithParams.href);
        return;
      }

      if (productCode) {
        this.router.navigate(['/products', productCode, 'welcome']);
      } else {
        this.router.navigate(['/products']);
      }

    } catch (err) {
      console.error(err);
      let message = 'An error occurred while processing your login request';
      if ((err as any).error?.code === 'island') {
        message = (err as any).error.message;
      }
      this.loginMessageService.setErrorMessage(message);
      this.router.navigate(['/logout']);
    }
  }

}
